import React from 'react';

export function NewRunModal({ onClose, onSelect }) {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <h2 className="text-lg font-semibold text-slate-900">Start a new run</h2>
        <p className="mt-1 text-sm text-slate-500">
          Create a batch, then add Size and/or Encapsulation files in one place.
        </p>
        <div className="mt-6 space-y-3">
          <button
            className="w-full rounded border border-slate-200 p-4 text-left hover:border-slate-900"
            onClick={() => onSelect('batch')}
          >
            <p className="font-semibold text-slate-900">Batch Run</p>
            <p className="text-sm text-slate-500">
              Provide batch details; upload Size/EE files from the workspace.
            </p>
          </button>
          <p className="rounded border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
            Create a Batch for one or more samples, then upload and group
            measurements in its workspace.
          </p>
        </div>
        <div className="mt-6 text-right">
          <button
            className="rounded border border-slate-200 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
